<template>
  <SelectWithSearch
    label="Conta"
    labelBusca="name"
    placeholder="Selecione uma conta"
    :disabled="disabled"
    :change="change"
    :options="accountCollection"
    :clearable="false"
    v-model="input"
  >
    <template slot="options" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
    <template slot="no-options"> Selecione uma conta </template>
    <template slot="selected" slot-scope="props">
      <div class="selected">{{ props.data.name }}</div>
    </template>
  </SelectWithSearch>
</template>

<script>
import { SelectWithSearch } from '@/components/Form';
import { mapActions, mapState } from 'vuex';

export default {
  name: 'SelectAccount',
  components: {
    SelectWithSearch,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {},
  },
  data() {
    return {
      input: null,
    };
  },
  async mounted() {
    await this.setAccountCollection();
    this.setDefaultAccount();
  },
  computed: {
    ...mapState('account', ['accountCollection']),
  },
  methods: {
    ...mapActions('account', ['setAccountCollection']),

    change(value) {
      this.$emit('input', value);
    },
    setDefaultAccount() {
      const account = this.accountCollection.find((e) => e.isDefault);

      this.change(account);
    },
  },
  watch: {
    value(current) {
      this.input = current;
    },
  },
};
</script>
